/**
 * 설정 페이지
 */

import { useNavigate } from "react-router-dom";
import { ChevronLeft, LogOut } from "lucide-react";
import { ProfileSection } from "@/components/settings/ProfileSection";
import { CompanySection } from "@/components/settings/CompanySection";
import { useAuth } from "@/hooks/useAuth";
import { useConfirm } from "@/contexts/ConfirmContext";
import { getAllRecords, STORES } from "@/lib/db";

export function SettingsPage() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const confirm = useConfirm();

  const handleLogout = async () => {
    // 미동기화 항목 개수 확인
    const syncQueue = await getAllRecords<{ status?: string }>(STORES.SYNC_QUEUE);
    const pendingCount = syncQueue.filter(
      (item) => !item.status || item.status === "pending" || item.status === "failed"
    ).length;

    // 경고 메시지 생성
    let message = "로그아웃하면 다음 데이터가 삭제됩니다:\n\n";
    message += "• 캐시된 프로젝트 및 설비 데이터\n";
    message += "• 로컬 사진 및 설비 템플릿\n";
    if (pendingCount > 0) {
      message += `• 미동기화 작업 ${pendingCount}개\n\n`;
      message += "⚠️ 미동기화 작업은 복구할 수 없습니다.";
    }
    message += "\n\n그래도 로그아웃하시겠습니까?";

    const confirmed = await confirm({
      title: "로그아웃",
      message,
      confirmText: "로그아웃",
      cancelText: "취소",
    });
    if (confirmed) {
      await logout();
      navigate("/login", { replace: true });
    }
  };

  return (
    <div className="min-h-full bg-slate-50">
      {/* 헤더 */}
      <div className="sticky top-0 z-10 bg-white px-4 py-3 shadow-sm">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="rounded-lg p-1 text-gray-600 hover:bg-gray-100"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
          <h1 className="text-xl font-semibold text-gray-900">설정</h1>
        </div>
      </div>

      {/* 섹션들 */}
      <div className="space-y-4 p-4">
        <ProfileSection />
        <CompanySection />

        {/* 로그아웃 버튼 */}
        <button
          type="button"
          onClick={handleLogout}
          className="flex w-full items-center justify-center gap-2 rounded-lg bg-white py-3 text-red-600 shadow-sm hover:bg-red-50"
        >
          <LogOut className="h-5 w-5" />
          <span className="font-medium">로그아웃</span>
        </button>
      </div>
    </div>
  );
}

export default SettingsPage;
